import { Carousel } from 'antd';
import React, { memo, useRef } from 'react';
import { useSelector } from 'react-redux';

import useControlCarousel from '../hooks/useControlCarousel';
import { RootState } from '../store';
import { CalendarScaleType } from '../types';
import CalendarDayWeek from './calendarDayWeek';
import CalendarMonth from './calendarMonth';

const CalendarCarousel = () => {
    const carouselRef = useRef<any>();
    const scheduleScale = useSelector<RootState, CalendarScaleType>((state) => state.calendar.scheduleScale);
    useControlCarousel(carouselRef);

    return (
        <Carousel ref={carouselRef} dots={false} lazyLoad={'ondemand'} effect="fade">
            <div>{scheduleScale === 'day' && <CalendarDayWeek type={scheduleScale} />}</div>
            <div>{scheduleScale === 'week' && <CalendarDayWeek type={scheduleScale} />}</div>
            <div>
                <CalendarMonth />
            </div>
        </Carousel>
    );
};

export default memo(CalendarCarousel);
